import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getMobileAppUsed, isUserDataFetched } from 'src/modules/user/selectors/userSelectors';

import { MobileAppInformationModal } from 'src/shared/components/MobileAppInformationModal';

const hasMinimalRequiredTimeElapsed = (closeDate: string | null): boolean => {
    // user will see the modal for the first time
    if (!closeDate) {
        return true;
    }

    const closeDateMoment = moment(closeDate);
    const now = moment();

    // the difference between a close modal date and now in days
    const diff = now.diff(closeDateMoment, 'd');

    // show the modal again only if at least 30 days elapsed
    return diff > 30;
};

export const MOBILE_APP_INFO_LOCALSTORAGE_KEY = 'mobileAppInfoModalCloseDate';

export const MobileAppInformationModalDashboard: React.FC = () => {
    const [modalClosed, setModalClosed] = useState(false);

    const userDataFetched = useSelector(isUserDataFetched);
    const mobileAppAlreadyUsed = useSelector(getMobileAppUsed);

    const handleModalClose = () => {
        setModalClosed(true);

        const now = moment().toISOString();

        localStorage.setItem(MOBILE_APP_INFO_LOCALSTORAGE_KEY, now);
    };

    // possibly null
    const closeDate = localStorage.getItem(MOBILE_APP_INFO_LOCALSTORAGE_KEY);

    const minimalRequiredTimeElapsed = hasMinimalRequiredTimeElapsed(closeDate);

    const modalVisible =
        !modalClosed && minimalRequiredTimeElapsed && userDataFetched && !mobileAppAlreadyUsed;

    useEffect(() => {
        if (modalVisible) {
            document.body.classList.add('remove-scroll');
        } else {
            document.body.classList.remove('remove-scroll');
        }
    }, [modalVisible]);

    return <MobileAppInformationModal isVisible={modalVisible} onModalClose={handleModalClose} />;
};
